// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3764":"90370f4a","3833":"a4a8694e","5712":"3f7d4aad"}[chunkId] + ".chunk.css";
};